import { getServiceProvider } from '@takeshape/service-providers';
import { avatars, logos } from '../assets';
import { createServiceProvider } from '../util';

export default createServiceProvider({
  ...getServiceProvider('shipEngine'),
  titleToNamespace: true,
  experimental: false,
  hasConnectionStatus: false,
  avatarPath: avatars.shipEngine,
  logoPath: logos.shipEngine
});
